import { GlobalPageLoadExperience } from '@atlassian/ufo';
import { perf } from '@databases/logs/performance';
import { appStore } from '@databases/redux/store';
import { loadDatabaseByReferenceId } from '@databases/utils/redux/databases/actions';

/**
 * For standalone, this dispatches the initial load of the document database.
 */
export function dispatchInitialDatabaseLoad({
  contentId,
  contentReferenceId,
  spaceId,
  spaceKey,
  spaceName,
  title,
  isPreview,
}: {
  contentId: string;
  contentReferenceId: string;
  spaceId: string | number;
  spaceKey: string;
  spaceName?: string;
  title?: string;
  isPreview?: boolean;
}) {
  perf.timeLog('app-initialization', 'database-load-start');
  GlobalPageLoadExperience.mark('database-load-start');

  appStore.dispatch(
    loadDatabaseByReferenceId(
      {
        contentId,
        referenceId: contentReferenceId,
        spaceId: Number(spaceId),
        spaceKey,
        spaceName: spaceName ?? '',
        title: title ?? '',
        isInitialLoad: true,
        isPreview,
      },
      {
        forceReload: true,
        throttle: true,
      },
    ),
  );
}
